"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfig = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var ConfigContext_1 = require("../../configprovider/ConfigContext");
function useConfig() {
    var context = react_1.useContext(ConfigContext_1.ConfigContext) || {};
    return tslib_1.__assign({ classPrefix: ConfigContext_1.DEFAULT_CLASS_PREFIX, locale: ConfigContext_1.DEFAULT_LOCALE }, context);
}
exports.useConfig = useConfig;
//# sourceMappingURL=use-config.js.map